<template>
  <a-dropdown-button
    v-bind="attrs"
    :class="bem.b()"
    :overlay-class-name="`${overlayClassName} ${bem.b('menu-wrapper')}`"
  >
    <span v-if="buttonLabel">{{ buttonLabel }}</span>
    <slot v-else> </slot>

    <!-- 菜单 -->
    <template #overlay>
      <slot v-if="$slots.overlay" name="overlay" />
      <a-menu v-else>
        <RecursiveMenu
          :items="props.dropdownItems"
          @claim-selected="handleMenuItemClick"
        />
      </a-menu>
    </template>

    <!-- 图标 -->
    <template v-if="$slots.icon || icon" #icon>
      <slot v-if="$slots.icon" name="icon" />
      <ll-icon v-else :icon-name="icon" />
    </template>
  </a-dropdown-button>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { useAttrs } from 'vue'
import type { DropdownItem } from './dropdown'
import { dropdownButtonEmits, dropdownButtonProps } from './dropdown'

import RecursiveMenu from './recursive-menu.vue'

defineOptions({ name: 'LlDropdownButton' })

// 定义组件的props
const props = defineProps(dropdownButtonProps)

const emits = defineEmits(dropdownButtonEmits)
const bem = createNamespace('dropdown-button')

const attrs = useAttrs()

// 定义处理菜单项点击的方法
const handleMenuItemClick = (item: DropdownItem) => {
  emits('claimSelected', item)
}
</script>
